var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',_vm._l((_vm.rows),function(row,rowIndex){return _c('table-tr',{key:'table-head-row-' + rowIndex,attrs:{"data":row}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }